import { Routes, Route, Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import Auth from "../screens/login/login";
import Dashboard from "../screens/services/Dashboard";
import Profile from "../screens/services/Profile";
import UserManagement from "../screens/services/userManagement";

const PrivateRoute = () => {
  const { isLoggedIn } = useSelector((state: any) => state.auth);
  return isLoggedIn ? <Outlet /> : <Navigate to="/" />;
};

const AdminRoute = () => {
  const role = useSelector(
    (state: any) => state.auth?.loginDetails?.role
  );
  return role === "admin" ? <Outlet /> : <Navigate to="/dashboard" />;
};

function MainNav() {
  const { isLoggedIn } = useSelector((state: any) => state.auth);

  return (
    <Routes>
      <Route
        path="/"
        element={isLoggedIn ? <Navigate to="/dashboard" /> : <Auth />}
      />
      <Route element={<PrivateRoute />}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/profile" element={<Profile />} />

        <Route element={<AdminRoute />}>
          <Route path="/user-management" element={<UserManagement />} />
        </Route>

        <Route
          path="/dashboard/:type/:deviceId/:userId/:tripIndex/:tripDate"
          element={<Dashboard />}
        />
      </Route>
    </Routes>
  );
}

export default MainNav;